// extracted by css-extract-rspack-plugin
export default {"paginationWrapper":"product-listing-fragment__ProductListPagination_paginationWrapper__TU8xU"};